import { v4 as uuidv4 } from 'uuid'
import { amplifyException } from '../../constants/amplify-api-constants'
import { appNameConstants } from '../../constants/app-constants'
import { serviceErrorWrapper } from './service-error-wrapper'
import { routePaths } from '../../constants/routes'
import { localStorageKeyConstants } from '../../constants/local-storage-key-constants'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'

export const axiosResponseErrorInterceptor = async (error) => {
  /* Redirect the user back to login when service
       returns unauthorized error */
  const wrappedError = serviceErrorWrapper(error)
  const requestUrl = error?.config?.url
  const ignoredApisWhenUnauthorized = [
    '/login',
    '/verifyMFAToken',
    '/verifyMFATokenForLogin',
    '/confirmInvite',
    '/resendInvite',
  ]
  if (
    (!ignoredApisWhenUnauthorized.includes(requestUrl) && wrappedError.status === 401) ||
    wrappedError.message === amplifyException.USER_IS_NOT_AUTHENTICATED
  ) {
    localStorage.clear()
    sessionStorage.clear()
    /* Window.location reloads the entire app.
       Do not use anywhere else.
       Window.location satisfies the use case
       here to take user back to login and start
       fresh.
    */
    window.location.replace(routePaths.LOGIN)
  }
  return Promise.reject(wrappedError)
}

export function getHeaders(token) {
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const headers = {
    'App-Name': appNameConstants.CLIENT_PORTAL,
    'Transaction-Id': uuidv4(),
    /* Try sending selected client code, otherwise send logged-in user's client code */
    'Client-Code':
      selectedClient?.clientCode || localStorage.getItem(localStorageKeyConstants.CLIENT_CODE),
    'Warehouse-Codes':
      sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_WAREHOUSE_CODES) ||
      localStorage.getItem(localStorageKeyConstants.WAREHOUSE_CODE),
    'DMS-Flag': selectedClient?.dmsFlag || localStorage.getItem(localStorageKeyConstants.DMS_FLAG),
    Username: localStorage.getItem(localStorageKeyConstants.STORED_USERNAME),
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return headers
}
